/** Kurze Rueckmeldung am unteren Rand ("Gespeichert"). */
let el: HTMLElement | null = null;
let timer = 0;

export function toast(message: string, ms = 1600): void {
  if (!el) {
    el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    document.body.append(el);
  }
  el.textContent = message;
  el.classList.add('toast--on');
  clearTimeout(timer);
  timer = window.setTimeout(() => el?.classList.remove('toast--on'), ms);
}
